import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import {
  commentsStateForEmployeeIdSelector,
  commentsStateForJobApplicantIdSelector,
} from '../comment-selectors';

import * as Api from '../../api/api';

export const loadApplicantComments = (context: { jobApplicantId: number }) =>
  createGenericDispatcher({
    name: 'LOAD_COMMENTS',
    loadFunction: () => Api.get(`/comment?context=${JSON.stringify(context)}`),
    args: { context },
    shouldExecuteSelector: (state: any) =>
      commentsStateForJobApplicantIdSelector(state, context.jobApplicantId),
  });

export const loadEmployeeComments = (context: { employeeId: number }) =>
  createGenericDispatcher({
    name: 'LOAD_COMMENTS',
    loadFunction: () => Api.get(`/comment?context=${JSON.stringify(context)}`),
    args: { context },
    shouldExecuteSelector: (state: any) =>
      commentsStateForEmployeeIdSelector(state, context.employeeId),
  });
